import { ChevronDown, Moon, Sun, Monitor } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { NavLink } from "react-router-dom"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useAuth } from "@/lib/auth"
import { TOP_NAV, topNavLinkClass } from "@/lib/nav"
import { useTheme } from "@/lib/theme"
import type { Theme } from "@/lib/config"

import { KitchenBrandLink } from "./KitchenBrand"

export function AppTopBar() {
  const { signOut, user } = useAuth()
  const navigate = useNavigate()
  const { setTheme, theme } = useTheme()

  return (
    <header className="no-print sticky top-0 z-40 border-b border-border bg-background/80 backdrop-blur-md">
      <div className="flex h-14 items-center justify-between gap-4 px-4">
        <div className="flex items-center gap-6">
          <KitchenBrandLink />
          <nav className="hidden items-center sm:flex">
            {TOP_NAV.map(({ label, section, to }) => (
              <NavLink
                className={({ isActive }) => topNavLinkClass(section, isActive)}
                key={to}
                to={to}
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button className="max-w-[min(100vw-8rem,280px)] gap-1" size="sm" variant="ghost">
              <span className="truncate text-sm">{user?.email ?? "Staff"}</span>
              <ChevronDown className="size-4 shrink-0 opacity-60" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel className="font-normal">
              <span className="truncate text-sm font-medium">{user?.email}</span>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuLabel>Appearance</DropdownMenuLabel>
            <DropdownMenuRadioGroup onValueChange={(v) => setTheme(v as Theme)} value={theme}>
              <DropdownMenuRadioItem value="dark">
                <Moon className="size-4" />
                Dark
              </DropdownMenuRadioItem>
              <DropdownMenuRadioItem value="light">
                <Sun className="size-4" />
                Light
              </DropdownMenuRadioItem>
              <DropdownMenuRadioItem value="system">
                <Monitor className="size-4" />
                System
              </DropdownMenuRadioItem>
            </DropdownMenuRadioGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onSelect={() => {
                void signOut().then(() => navigate("/login"))
              }}
              variant="destructive"
            >
              Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  )
}
